import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './admin.component';
import { AgenciaDetalleComponent } from './agencia-detalle/agencia-detalle.component';
import { AgenciasAdminComponent } from './agencias-admin/agencias-admin.component';
import { AgenciasPendientesComponent } from './agencias-pendientes/agencias-pendientes.component';
import { DashboardAdminComponent } from './dashboard-admin/dashboard-admin.component';
import { PacksAdminComponent } from './packs-admin/packs-admin.component';
import { PasajerosAdminComponent } from './pasajeros-admin/pasajeros-admin.component';
import { PasajeroConfirmadoComponent } from './pasajero-confirmado/pasajero-confirmado.component';
import { PasajeroReservadoComponent } from './pasajero-reservado/pasajero-reservado.component';
import { TourAgenciasConfirmadasDetalleComponent } from './tour-agencias-confirmadas-detalle/tour-agencias-confirmadas-detalle.component';
import { TourAgenciasConfirmadasComponent } from './tour-agencias-confirmadas/tour-agencias-confirmadas.component';
import { TourAgenciasReservadosComponent } from './tour-agencias-reservados/tour-agencias-reservados.component';
import { TourExcursionesComponent } from './tour-excursiones/tour-excursiones.component';
import { TourAgenciasComponent } from './tour-agencias/tour-agencias.component';
import { TourItinerarioComponent } from './tour-itinerario/tour-itinerario.component';
import { TourUpdateComponent } from './tour-update/tour-update.component';
import { ToursAdminComponent } from './tours-admin/tours-admin.component';
import { ToursConfirmadosComponent } from './tours-confirmados/tours-confirmados.component';
import { ToursCreateComponent } from './tours-create/tours-create.component';

const routes: Routes = [{
    path: '',
    component: AdminComponent,
    children: [
      {
        path: 'dashboard',
        component: DashboardAdminComponent,
      },
      {
        path: 'tours',     //*** tours reservados
        component: ToursAdminComponent,
      },
      {
        path: 'tours-agencias',    //*** tours agencias reservados
        component: TourAgenciasComponent,
      },
      {
        path: 'tours-confirmados',
        component: ToursConfirmadosComponent,
      },
      {
        path: 'packs',
        component: PacksAdminComponent,
      },
      {
        path: 'agencias',
        component: AgenciasAdminComponent,
      },
      {
        path: 'agencias-pendientes',
        component: AgenciasPendientesComponent,
      },
      {
        path: 'perfil-pendiente/:id',
        component: AgenciaDetalleComponent,
      },
      {
        path: 'perfil/:id',
        component: AgenciaDetalleComponent,
      },
      {
        path: 'tours-register',
        component: ToursCreateComponent,
      },
      {
        path: 'tours-agencias-confirmadas',
        component: TourAgenciasConfirmadasComponent,
      },
      {
        path: 'tours-update/:id',
        component: TourUpdateComponent,
      },
      {
        path: 'tours-agencias-confirmadas-detalle',
        component: TourAgenciasConfirmadasDetalleComponent,
      },
      {
        path: 'tours-agencias-reservados',       //*** tours agencias reservados detalles
        component: TourAgenciasReservadosComponent,
      },
      {
        path: 'pasajeros',
        component: PasajerosAdminComponent,
      },
      {
        path: 'pasajero-reservado',
        component: PasajeroReservadoComponent,
      },
      {
        path: 'pasajero-confirmado',
        component: PasajeroConfirmadoComponent,
      },
      {
        path: 'tour-itinerario/:id',
        component: TourItinerarioComponent,
      },
      {
        path: 'tour-excursiones/:id',
        component: TourExcursionesComponent,
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        // otherwise redirect to home
        path: '**',
        redirectTo: '',
      },
    ],
  }];


@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
  })
  export class AdminRoutingModule { }
